import React from "react";
import "./MiniLoader.css";

export const MiniLoader = () => {
  return (
    <div className="mini-loader-wrapper">
      <div className="miniCoffee">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
